import { ThresholdLevel } from 'pages/ReportsPage/components/AnalyticsDashboards/chartColors';
import { FulfillmentDashboardStore } from 'pages/ReportsPage/components/AnalyticsDashboards/FulfillmentDashboard/store/fulfillmentDashboard.store.types';
import { LAST_MINUTE_CANCELLATIONS_STUB } from 'pages/ReportsPage/components/AnalyticsDashboards/FulfillmentDashboard/store/lastMinuteCancellations.stub';
import {
  PEAK_CALLOUT_CELLS_STUB,
  RESOLUTION_SPEED_CELLS_STUB,
} from 'pages/ReportsPage/components/AnalyticsDashboards/dataLockedStubData';

export const FULFILLMENT_DATA_LOCKED_STUB: Partial<FulfillmentDashboardStore> = {
  totalAssignedShifts: 10809,
  totalAssignedShiftsPeriodDays: 7,
  totalAssignedShiftsChangePrct: 3,
  totalCalloutShifts: 2081,
  totalCalloutShiftsPeriodDays: 7,
  totalCalloutShiftsChangePrct: -5,
  fulfillmentRate: 92.02,
  fulfillmentRatePeriodDays: 7,
  fulfillmentRateChangePrct: 2.1,
  cancelledShifts: 987,
  cancelledShiftsPeriodDays: 7,
  cancelledShiftsChangePrct: 12,
  lastMinuteCancellationDetails: LAST_MINUTE_CANCELLATIONS_STUB,
  lastMinuteCancellationTotalCount: LAST_MINUTE_CANCELLATIONS_STUB.length,
  lastMinuteCancellationPage: 1,
  lastMinuteCancellationTotalPages: 1,
  calloutRateByPosition: [
    { position: 'Wellness Nurse', assignedShifts: 98, calloutShifts: 15 },
    { position: 'Medication Care Partner', assignedShifts: 90, calloutShifts: 18 },
    { position: 'Life Enrichment Assistant', assignedShifts: 85, calloutShifts: 12 },
    { position: 'Concierge', assignedShifts: 88, calloutShifts: 14 },
    { position: 'Resident Care Partner (PSW)', assignedShifts: 100, calloutShifts: 20 },
  ],
  fulfillmentByTimeframe: [
    {
      timeframe: 'Morning',
      fulfillmentPercentage: 88,
      totalShifts: 820,
      thresholdLevel: ThresholdLevel.ON_TARGET,
    },
    {
      timeframe: 'Evening',
      fulfillmentPercentage: 76,
      totalShifts: 640,
      thresholdLevel: ThresholdLevel.MONITOR,
    },
    {
      timeframe: 'Overnight',
      fulfillmentPercentage: 62,
      totalShifts: 382,
      thresholdLevel: ThresholdLevel.CRITICAL,
    },
  ],
  fulfillmentByPosition: [
    {
      position: 'Wellness Nurse',
      fulfillmentPercentage: 88,
      totalShifts: 520,
      thresholdLevel: ThresholdLevel.ON_TARGET,
      avgCalloutFulfillmentLagHours: 200,
    },
    {
      position: 'Medication Care Partner',
      fulfillmentPercentage: 84,
      totalShifts: 380,
      thresholdLevel: ThresholdLevel.MONITOR,
      avgCalloutFulfillmentLagHours: 340,
    },
    {
      position: 'Resident Care Partner (PSW)',
      fulfillmentPercentage: 79,
      totalShifts: 480,
      thresholdLevel: ThresholdLevel.MONITOR,
      avgCalloutFulfillmentLagHours: 180,
    },
    {
      position: 'Housekeeper',
      fulfillmentPercentage: 76,
      totalShifts: 280,
      thresholdLevel: ThresholdLevel.MONITOR,
      avgCalloutFulfillmentLagHours: 210,
    },
    {
      position: 'Server',
      fulfillmentPercentage: 72,
      totalShifts: 182,
      thresholdLevel: ThresholdLevel.ATTENTION,
      avgCalloutFulfillmentLagHours: 170,
    },
  ],
  peakCalloutHours: PEAK_CALLOUT_CELLS_STUB,
  resolutionSpeed: RESOLUTION_SPEED_CELLS_STUB,
  unfulfilledShiftDetails: [
    {
      date: 'Apr 22',
      shiftId: 'Shift #203044',
      location: 'Seasons Owen Sound',
      position: 'Medication Care Partner',
      timeframe: 'Morning',
      totalEligible: 49,
      available: 25,
      otEligible: 10,
      otAllowed: 'Yes',
      noResponseReason: 'Already on shift (6), Overtime limit (3), Unavailable (2)',
      skipReasonBreakdown: { 'Already on shift': 6, 'Overtime limit': 3, Unavailable: 2 },
      leadTime: '2.8h',
    },
    {
      date: 'Apr 22',
      shiftId: 'Shift #203043',
      location: 'Seasons Amherstburg',
      position: 'Wellness Nurse',
      timeframe: 'Overnight',
      totalEligible: 58,
      available: 28,
      otEligible: 12,
      otAllowed: 'No',
      noResponseReason: 'No response (5), Overtime limit (3), Schedule conflict (2)',
      skipReasonBreakdown: { 'No response': 5, 'Overtime limit': 3, 'Schedule conflict': 2 },
      leadTime: '1.2h',
    },
    {
      date: 'Apr 23',
      shiftId: 'Shift #203051',
      location: 'Seasons Cambridge',
      position: 'Resident Care Partner (PSW)',
      timeframe: 'Morning',
      totalEligible: 120,
      available: 80,
      otEligible: 30,
      otAllowed: 'Yes',
      noResponseReason: 'Already on shift (4), No response (3), Schedule conflict (2)',
      skipReasonBreakdown: { 'Already on shift': 4, 'No response': 3, 'Schedule conflict': 2 },
      leadTime: '3.4h',
    },
    {
      date: 'Apr 23',
      shiftId: 'Shift #203052',
      location: 'Seasons Camrose',
      position: 'Housekeeper',
      timeframe: 'Evening',
      totalEligible: 40,
      available: 22,
      otEligible: 9,
      otAllowed: 'Yes',
      noResponseReason: 'Unavailable (3), No response (2), Overtime limit (1)',
      skipReasonBreakdown: { Unavailable: 3, 'No response': 2, 'Overtime limit': 1 },
      leadTime: '2.1h',
    },
    {
      date: 'Apr 23',
      shiftId: 'Shift #203053',
      location: 'Seasons Belle River',
      position: 'Wellness Nurse',
      timeframe: 'Overnight',
      totalEligible: 60,
      available: 30,
      otEligible: 11,
      otAllowed: 'No',
      noResponseReason: 'No response (7), Overtime limit (4), Already on shift (2)',
      skipReasonBreakdown: { 'No response': 7, 'Overtime limit': 4, 'Already on shift': 2 },
      leadTime: '0.6h',
    },
  ],
  unfulfilledShiftDetailPage: 1,
  unfulfilledShiftDetailTotalPages: 1,
};
